// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_mt-0";